import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4995ddc3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4995ddc3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4995ddc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4995ddc3')) {
      api.createRecord('4995ddc3', component.options)
    } else {
      api.reload('4995ddc3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4995ddc3&scoped=true", function () {
      api.rerender('4995ddc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/international/home/index.vue"
export default component.exports